<template lang="pug">
  v-app.simple
    bar-and-nav(v-model="navDrawer" :links="links")
      scrollactive(:offset='200' :scroll-offset='70')
        nav-list(:items="items")
    v-main.main.w-100
      v-container(fluid).pa-0
        v-card(v-for="item in items" :key="item.slug" :id="item.slug" outlined).ma-4
          v-card-title
            h1.text-center.black--text.mb-0(style="width:100%") {{item.title}}
          embed-frame(:url="item.embed" :width="embedWidth" :y-offset="37").mx-4
          v-card-text.body-2
            vue-markdown {{item.content}}
      v-footer(color="#005cb8")
        p.ma-auto.white--text.body-2 Copyright © {{new Date().getFullYear()}} Arlington County Virginia
</template>

<script>
import BarAndNav from '@/components/BarAndNav.vue'
import EmbedFrame from '@/components/EmbedFrame.vue'
import NavList from '@/components/NavList.vue'
import VueMarkdown from 'vue-markdown'

export default {
  components: {
    BarAndNav,
    EmbedFrame,
    NavList,
    VueMarkdown
  },
  props: ['items', 'links'],
  data: () => ({
    navDrawer: undefined
  }),
  computed: {
    embedWidth () {
      const NAV_WIDTH = 256
      const MARGIN = 16
      return (this.$vuetify.breakpoint.width - NAV_WIDTH - MARGIN * 4)
    }
  }
}
</script>

<style lang="stylus">
.simple
  .main
    position:absolute
</style>